// AdminLayout — sidebar nav + shell for the admin role. "Payments" carries an
// amber pending-count badge, shared via its own context. It loads on mount and is
// refetched by useVerifyPayment after any payment is settled (Payments page,
// dashboard recent-payments card, student detail page). The nav itself (sidebar on
// desktop, drawer on mobile) is rendered by the shared AppShell.
import { PaymentsPendingCountProvider, usePaymentsPendingCount } from "../../contexts/PaymentsPendingCountContext.js";
import AppShell, { type NavItem } from "./AppShell.js";

const NAV_ITEMS: readonly NavItem[] = [
  { to: "/app/admin",              label: "Dashboard",    end: true },
  { to: "/app/admin/users",        label: "Users",        end: false },
  { to: "/app/admin/courses",      label: "Courses",      end: false },
  { to: "/app/admin/sessions",     label: "Sessions",      end: false },
  { to: "/app/admin/enrollments",  label: "Enrollments",  end: false },
  { to: "/app/admin/payments",     label: "Payments",     end: false },
  { to: "/app/admin/certificates", label: "Certificates", end: false },
  { to: "/app/admin/activity",     label: "Activity",     end: false },
  { to: "/app/admin/profile",      label: "Profile",      end: false },
  { to: "/app/admin/config",       label: "System Config", end: false },
];

function AdminShell() {
  const { pendingCount: pendingPayments } = usePaymentsPendingCount();

  const badgeCountFor = (label: string): number | null => {
    if (label === "Payments") return pendingPayments;
    return null;
  };

  return <AppShell title="Admin" items={NAV_ITEMS} badgeFor={badgeCountFor} />;
}

export default function AdminLayout() {
  return (
    <PaymentsPendingCountProvider>
      <AdminShell />
    </PaymentsPendingCountProvider>
  );
}
